/**
 * Base Component
 * 
 * @copyright NIIT Technologies Ltd. 2017-18
 */
// Angular
import {
    Component, Injectable, Inject, ReflectiveInjector, NgZone,
    OnInit, OnDestroy, AfterContentInit, AfterContentChecked, AfterViewInit, AfterViewChecked, OnChanges,
    ElementRef, ViewChildren, ContentChildren, QueryList, HostListener, ChangeDetectorRef,
    Input, SimpleChanges, forwardRef, Renderer
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
// Core
import { Event, NotificationType, BaseResponse, ErrorMessage } from '../common/base.data';
import { EventService } from '../service/event.service';

/**
 * Base Component for All  Components
 */
export abstract class BaseComponent implements OnInit, OnDestroy, OnChanges,
    AfterContentInit, AfterContentChecked, AfterViewInit, AfterViewChecked {
    //
    private static eventService: EventService = null;
    private componentEventSubscription: Subscription = null;

    /**
     * Initialize
     */
    constructor(protected zone: NgZone, protected element: ElementRef, protected renderer: Renderer) {
        if (!BaseComponent.eventService) {
            let injector = ReflectiveInjector.resolveAndCreate([EventService]);
            // If Event Service Available
            if (injector) {
                BaseComponent.eventService = injector.get(EventService);
            }
        }
    }

    /**
     * On Initialization
     */
    public ngOnInit() {
    }

    /**
     * After Content Initialization
     */
    public ngAfterContentInit() {
    }

    /**
     * After Content Checked
     */
    public ngAfterContentChecked() {
    }

    /**
     * After View Initialization
     */
    public ngAfterViewInit() {
    }

    /**
     * After View Checked
     */
    public ngAfterViewChecked() {
    }

    /**
     * On Destroy
     */
    public ngOnDestroy() {
        this.destroy();
    }

    /**
     * On Changes
     */
    public ngOnChanges(changes: SimpleChanges) {
    }

    /**
     * Subscribe Component Event
     */
    protected subscribeComponentEvents(): void {
        // If Already Subscribed, Unsubscribe
        if (this.componentEventSubscription) {
            this.componentEventSubscription.unsubscribe();
            this.componentEventSubscription = null;
        }
        // Subscribe
        BaseComponent.eventService.getEventObserver().subscribe(event => {
            this.handleComponentEvent(event);
        }, error => {
            console.log("Global Component Event Error");
            console.log(error);
        });
    }

    /**
     * Handle Component Event Raised by Another Component
     */
    protected handleComponentEvent(event: Event): void { }

    /**
     * Raise Component Event
     * 
     * @param eventId Event Id
     * @param sourceId Source Id
     * @param targetId Target Id
     * @param data Data
     */
    protected broadcast(eventId: string, sourceId: string, targetId: string, data: any): void {
        let event: Event = new Event();
        // Set Default
        event.eventId = eventId;
        event.sourceId = sourceId;
        event.targetId = targetId;
        event.data = data;
        // Raise Event
        BaseComponent.eventService.raiseEvent(event);
    }

    /**
     * Fire Dummy Event on Element
     */
    protected fireDummyEvent() {
        if (this.renderer) {
            let htmlEvent = document.createEvent("HTMLEvents");
            //
            htmlEvent.initEvent("input", true, true);
            //
            this.renderer.invokeElementMethod(this.element.nativeElement, 'dispatchEvent', [htmlEvent]);
        }
    }

    /**
     * Is Touch Device
     */
    protected isTouchDevice(): boolean {
        return ('ontouchstart' in window);
    }

    /**
     * Destroy Service
     */
    protected destroy(): void {
        if (this.componentEventSubscription) {
            this.componentEventSubscription.unsubscribe();
            this.componentEventSubscription = null;
        }
    }

}